import { COMPANY_API } from 'apis';
import storage from 'helpers/storage';

const NS = '/captain-payment';

export const getStoreList = async (params) => {
  const result = await COMPANY_API.get(`${NS}/pass/v1/store`, { params });
  return result.data;
};

export const GetService = async () => {
  var result = await COMPANY_API.get(`${NS}/service/v1`);

  if (result.status == 200) return result.data;

  return result;
};

export const GetPublicService = async () => {
  var result = await COMPANY_API.get(`${NS}/pass/v1/me`);
  if (result.status == 200) return result.data;

  return result;
};

export const GetDormantUsers = async (params) => {
  const result = await COMPANY_API.get(`${NS}/member/v1/dormant`, { params });
  return result.data;
};

export const GetDormantUser = async (userId) => {
  const result = await COMPANY_API.get(`${NS}/member/v1/dormant/${userId}`);
  return result.data;
};

export const getServiceAgreement = async () => {
  var result = await COMPANY_API.get('/captain-payment/service/v1');
  return result.data;
};

export const startService = async (serviceType) => {
  var result = await COMPANY_API.put('/captain-payment/service/v1', {
    serviceType,
    status: 'ACTIVE'
  });
  return result;
};

export const stopService = async (serviceType) => {
  var result = await COMPANY_API.put('/captain-payment/service/v1', {
    serviceType,
    status: 'INACTIVE'
  });
  return result;
};

export const getMeInfo = async (userId) => {
  const result = await COMPANY_API.get(`/captain-payment/pass/v1/me`);
  // const result = await COMPANY_API.get(`/addons/v1/me`);
  // storage.set('company', {
  //   userID: form.userID ? form.userID.toLowerCase() : id.toLowerCase(),
  //   user: companyInfo.data.user,
  //   id: companyId || companyInfo.data.user.company.id,
  //   info: companyInfo.data.user.company,
  //   list: companyInfo.data.company
  // })

  storage.set('userCount', { userCount: result.data.companyInfo?.userCount });
  return result.data;
};
export const getMyProfile = async (params) => {
  const result = await COMPANY_API.get(`/captain-payment/pass/v1/employee`, { params });
  return result.data;
};

export const modifyMyProfile = async (userId, data) => {
  const result = await COMPANY_API.put(`${NS}/member/v1/${userId}`, data);
  return result;
};

export const getSikdaePermission = async (params) => {
  const result = await COMPANY_API.get(`/captain-payment/pass/v1/service/application`, { params });
  return result.data;
};

export const applySikdeSerivce = async (data) => {
  const result = await COMPANY_API.post(`/captain-payment/pass/v1/service/application`, data);
  return result.data;
};

export const getMembers = async (params) => {
  const result = await COMPANY_API.get(`/captain-payment/member/v1`, { params });
  return result.data;
};

export const getDivision = async (params) => {
  const result = await COMPANY_API.get(`/captain-payment/member/v1/division`, { params });
  return result.data;
};

export const addDivision = async (params) => {
  const result = await COMPANY_API.post(`/captain-payment/member/v1/division`, params);
  return result.data;
};

export const modifyDivision = async (params) => {
  const result = await COMPANY_API.put(`/captain-payment/member/v1/division/${params.id}`, params);
  return result.data;
};

export const removeDivision = async (params) => {
  const result = await COMPANY_API.delete(`/captain-payment/member/v1/division/${params.id}`);
  return result.data;
};

export const getDivisionCount = async (params) => {
  const result = await COMPANY_API.get(`/captain-payment/member/v1/division/user-count`, { params });
  return result.data;
};
